import { writable } from 'svelte/store'

// raw API data from each endpoint
export const stops = writable(false) // array of objects
export const stopArrivalTimes = writable(false) //array of objects
export const mapVehiclePoints = writable(false) //array of objects
export const routes = writable(false) // array of objects
export const routesForMapWithScheduleWithEncodedLine = writable(false) // array of objects
export const googleMapsReady = writable(false)
stops.set([])
stopArrivalTimes.set([])
mapVehiclePoints.set([])
routes.set([])
routesForMapWithScheduleWithEncodedLine.set([])
